

import { SpacerIcon } from "../Icons/ComponentIcons";
import {  WBComponent } from "./WBComponent";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";
import { defaultDropList } from "../Data/WBComponentDefaults";
import CreateAttributeList from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";






export default class Spacer extends WBComponent {

    


    constructor(){
        super();
        this.typename =wBComponentTypeNames.spacer;
        this.displayName = "Spacer";
        this.dropList = defaultDropList;
        this.editList =  CreateAttributeList(true,false,true,true,false);
        this.contentEditable = false;
        this.icon = <SpacerIcon/>
        
    }



    RenderLayout({component,children,screenSize,isEditor}:WBRenderProps)
     {

        return (


            <div {...GetNodeDomAttributes("v-spacer max-100",component,screenSize,isEditor)}></div>
        )

    }

}